"use strict";
(function () {

    var _ = require('lodash'),
        TweenMax = require('gsap'),
        Scene = require('./threejs/AbstractScene'),
        THREE = require('three'),
        UIControls = require('./ui-controls');

    var _createCSS3DObjectWithClassName = (className) => {
            var el = document.createElement('div');
            el.classList.add('map');
            return new THREE.CSS3DObject(el);
        },
        _createMapItems = function (map) {
            var container = document.getElementById('container');
            var el = container.querySelectorAll('.icon'),
                tx, ty;

            _.each(el, function (tile) {
                tx = parseFloat(tile.dataset.x);
                ty = parseFloat(tile.dataset.y) * -1;

                if (!isNaN(tx) && !isNaN(ty)) {
                    var tile3d = new THREE.CSS3DObject(tile);
                    tile3d.position.set(tx, ty, 0);
                    tile3d.origin = tile3d.position.clone();
                    this.items.push(tile3d);
                    map.add(tile3d);
                }



            }, this);
        };

    var _zoomInc = 400,
        _zoomSteps = 2,
        _zoomIndex = 0,
        _currentView = null;


    var INTRO_VIEW = 'intro-view',
        DEFAULT_VIEW = 'default-view',
        QUIZ_VIEW = 'quiz-view',
        INTRO_MOBILE_CAMERA_POSITION = new THREE.Vector3(50, 100, 800),
        QUIZ_MOBILE_CAMERA_POSITION = new THREE.Vector3(200, 100, 1000),
        DEFAULT_MOBILE_CAMERA_POSITION = new THREE.Vector3(0, 0, 1800),
        INTRO_DESKTOP_CAMERA_POSITION = new THREE.Vector3(50, 100, 700),
        QUIZ_DESKTOP_CAMERA_POSITION = new THREE.Vector3(200, 100, 1000),
        DEFAULT_DESKTOP_CAMERA_POSITION = new THREE.Vector3(200, 100, 1800);

    var _onresize = function () {
        var position;
        switch (_currentView) {
        case QUIZ_VIEW:
            position = document.body.classList.contains('mobile') ? QUIZ_MOBILE_CAMERA_POSITION : QUIZ_DESKTOP_CAMERA_POSITION;
            break;
        case INTRO_VIEW:
            position = document.body.classList.contains('mobile') ? INTRO_MOBILE_CAMERA_POSITION : INTRO_DESKTOP_CAMERA_POSITION;
            break;
        case DEFAULT_VIEW:
            position = document.body.classList.contains('mobile') ? DEFAULT_MOBILE_CAMERA_POSITION : DEFAULT_DESKTOP_CAMERA_POSITION;
            break;
        }
        
        this.scene.camera.position.set(position.x, position.y, position.z);        
        
    };


    var Map = function () {
        this.init();
        this.uicontrols = new UIControls(this);
    };
    Map.prototype = {

        init: function () {
            var container = document.getElementById('container'),
                map = _createCSS3DObjectWithClassName('map'),
                mapContainer = _createCSS3DObjectWithClassName('map-container');

            this.container = container;
            this.numbers = container.querySelectorAll('.number');
            this.streets = container.querySelectorAll('.street');
            this.labels = container.querySelectorAll('.label');
            this.office = container.querySelector('.office');
            //            this.location = container.querySelector('.location');

            map.add(mapContainer);

            this.scene = new Scene(container);
            this.scene.init();
            this.scene.add(map);

            this.items = [];
            _.bind(_createMapItems, this)(mapContainer);

            this.blocks = _.shuffle(this.items.filter(function (item) {
                return item.element.classList.contains('block');
            }));

            this.scene.camera.position.set(0, 0, 1946);
            this.scene.camera.position.set(0, 0, 700);
            map.position.set(-850 / 2, 885 / 2, 0);

            this.scene.camera.rotation.set(0, 0, 30 * Math.PI / 180);
            //            this.scene.addEventListener(EnterFrame.RENDER, _.bind(_onEnter, this));
            
            
            window.addEventListener('resize', _.bind(_onresize, this));
            
            this.scene.start();
            this.playIn();
        },
        gotoIntro: function () {
            _currentView = INTRO_VIEW;
            TweenMax.to(this.scene.camera.rotation, 1, {
                z: 30 * Math.PI / 180
            });

            var position = document.body.classList.contains('mobile') ? INTRO_MOBILE_CAMERA_POSITION : INTRO_DESKTOP_CAMERA_POSITION;

            TweenMax.to(this.scene.camera.position, 1, {
                x: position.x,
                y: position.y,
                z: position.z
            });
        },
        gotoDefault: function () {
            _currentView = DEFAULT_VIEW;
            _zoomIndex = 0;
            TweenMax.to(this.scene.camera.rotation, 1, {
                z: 30 * Math.PI / 180
            });

            var position = document.body.classList.contains('mobile') ? DEFAULT_MOBILE_CAMERA_POSITION : DEFAULT_DESKTOP_CAMERA_POSITION;

            TweenMax.to(this.scene.camera.position, 1, {
                x: position.x,
                y: position.y,
                z: position.z
            });
        },
        gotoQuiz: function () {
            _currentView = QUIZ_VIEW;
            TweenMax.to(this.scene.camera.rotation, 1, {
                z: -30 * Math.PI / 180
            });

            var position = document.body.classList.contains('mobile') ? QUIZ_MOBILE_CAMERA_POSITION : QUIZ_DESKTOP_CAMERA_POSITION;

            TweenMax.to(this.scene.camera.position, 1, {
                x: position.x,
                y: position.y,
                z: position.z
            });
        },

        playIn: function () {
            TweenMax.to(this.container, 1, {
                opacity: 1,
                onStart: () => {
                    this.container.style.display = "block";
                }
            });
        },
        playOut: function () {},

        zoomIn: function () {
            var z = (1800 - (_zoomIndex * _zoomInc)) - _zoomInc;
            var limit = 1800 - _zoomSteps * _zoomInc;
            if (z >= limit) {
                _zoomIndex++;
                TweenMax.to(this.scene.camera.position, 1, {
                    z: z,
                    ease: Cubic.easeOut
                });
            }
            if (z <= limit) {
                return -1;
            }
        },
        zoomOut: function () {
            var z = (1800 - (_zoomIndex * _zoomInc)) + _zoomInc;
            var limit = 1800;
            if (z <= limit) {
                _zoomIndex--;
                TweenMax.to(this.scene.camera.position, 1, {
                    z: z,
                    ease: Cubic.easeOut
                });
            }
            if (z >= limit) {
                return -1;
            }
        },

        select: function (index) {
            index = parseFloat(index);
            if (this.currentNumber) {
                this.currentNumber.classList.remove('current');
            }
            _.each(this.numbers, function (number) {
                var className = "-map-number-" + (index < 10 ? "0" + index : index);
                if (number.classList.contains(className)) {
                    this.currentNumber = number;
                    this.currentNumber.classList.add('current');
                }
            }, this);
        },
        deselect: function () {
            if (this.currentNumber) {
                this.currentNumber.classList.remove('current');
            }
        },

        flipBlocks: function () {
            _.each(this.blocks, function (block, index) {

                var rotateX = Math.round(Math.random()) === 1,
                    tweenObj = {
                        ease: Back.easeOut,
                        delay: index * 0.015
                    };
                if (rotateX) {
                    tweenObj.x = Math.PI * 2;
                    tweenObj.onComplete = function () {
                        block.rotation.x = 0;
                    };
                } else {
                    tweenObj.y = Math.PI * 2;
                    tweenObj.onComplete = function () {
                        block.rotation.y = 0;
                    }
                }

                TweenMax.to(block.rotation, 1.4, tweenObj);
            });
        },

        showNumbers: function () {

            TweenMax.to(this.numbers, 1, {
                opacity: 1,
                onStart: _.bind(function () {
                    _.each(this.numbers, function (el) {
                        el.style.display = 'block';
                    });
                }, this)
            });
        },
        hideNumbers: function () {
            TweenMax.to(this.numbers, 1, {
                opacity: 0,
                onComplete: _.bind(function () {
                    _.each(this.numbers, function (el) {
                        el.style.display = 'none';
                    });
                }, this)
            });
        },

        showStreets: function () {
            TweenMax.to(this.streets, 1, {
                opacity: 1,
                onStart: _.bind(function () {
                    _.each(this.streets, function (el) {
                        el.style.display = 'block';
                    });
                }, this)
            });
        },
        hideStreets: function () {
            TweenMax.to(this.streets, 1, {
                opacity: 0,
                onComplete: _.bind(function () {
                    _.each(this.streets, function (el) {
                        el.style.display = 'none';
                    });
                }, this)
            });
        },

        showLabels: function () {
            TweenMax.to(this.labels, 1, {
                opacity: 1,
                onStart: _.bind(function () {
                    _.each(this.labels, function (el) {
                        el.style.display = 'block';
                    });
                }, this)
            });
        },
        hideLabels: function () {
            TweenMax.to(this.labels, 1, {
                opacity: 0,
                onComplete: _.bind(function () {
                    _.each(this.labels, function (el) {
                        el.style.display = 'none';
                    });
                }, this)
            });
        },

        showOffice: function () {
            TweenMax.killChildTweensOf(this.office);
            TweenMax.to(this.office, 1, {
                opacity: 1,
                onStart: _.bind(function () {
                    this.office.style.display = 'block';
                }, this)
            });
        },
        hideOffice: function () {
            TweenMax.killChildTweensOf(this.office);
            TweenMax.to(this.office, 1, {
                opacity: 0,
                onComplete: _.bind(function () {
                    this.office.style.display = 'none';
                }, this)
            });
        },

        showControls: function () {
            this.uicontrols.show();
            this.uicontrols.enable();
        },
        hideControls: function () {
            this.uicontrols.hide();
            this.uicontrols.disable();
        },
        showZoom: function () {
            this.uicontrols.showZoom();
        },
        hideZoom: function () {
            this.uicontrols.hideZoom();
        }



    };
    module.exports = Map;

}());


/** WEBPACK FOOTER **
 ** ./holiday-map/map.js
 **/